import { useCurrentUserQuery } from "src/utils/hooks/useCurrentUser.generated";
import { UserType } from "~generated/graphqlTypes";

export function useCurrentUser() {
  const { data } = useCurrentUserQuery({ fetchPolicy: "cache-first" });
  return {
    currentUser: data?.currentUser,
    isInternal: data?.currentUser?.type === UserType.Internal,
    isHomeowner: data?.currentUser?.type === UserType.Homeowner,
  };
}
